/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {localTimeNullable} from 'common/yup/customs/localTimeNullable';

export const DailyWindow = yup.object({
   from: localTimeNullable(), // timeObj().nullable(),
   until: localTimeNullable(), // timeObj().nullable(),
   // pane1: yup.object({
   //    begin: yup.date(),
   //    end: yup.date(),
   // }),
   // pane2: yup.object({
   //    begin: yup.date(),
   //    end: yup.date(),
   // }),
});
export type IDailyWindow = yup.InferType<typeof DailyWindow>;
